import React, { useState, useEffect } from "react";
import Sidebar from "../components/Layout/Sidebar";
import Header from "../components/Layout/Header";
import UserList from "../modules/UserManagement/UserList";
import UserForm from "../modules/UserManagement/UserForm";
import StockList from "../modules/StockManagement/StockList";
import StockForm from "../modules/StockManagement/StockForm";
import OrderForm from "../modules/OrderManagement/OrderForm";
import OrderSettings from "../modules/OrderManagement/OrderSettings";

import OrderList from "../modules/OrderManagement/OrderList";
import OrderListCompiled from "../modules/OrderManagement/OrderListCompiled";
import ProfitReport from "../modules/Reports/ProfitReport";
import StockReport from "../modules/Reports/StockReport";
import ProfitByDistrict from "../modules/Reports/ProfitByDistrict";

import Cart from "../modules/CartManagement/Cart";
import SummaryCard from "../components/Dashboard/SummaryCard";
import AlertPanel from "../components/Dashboard/AlertPanel";
import { ORDER_STATUS } from "../utils/orderStatus";

import "../styles/Dashboard.css";

import { db } from "../services/firebaseConfig";
import { collection, query, where, getCountFromServer, getDocs } from "firebase/firestore";




const Dashboard = ({ userRole, userId, userDistrict, branchName }) => {
    const [selectedModule, setSelectedModule] = useState(() => {
        if (userRole === "pengurus") return "Kedai";
        if (userRole === "pengerusi" || userRole === "pengarah") return "Dashboard";
        return "";
    });


    const [drawerOpen, setDrawerOpen] = useState(false);
    const [userData, setUserData] = useState(null);
    const [hasPendingCompiled, setHasPendingCompiled] = useState(false);

    const [cartItems, setCartItems] = useState([]);
    const [summary, setSummary] = useState({
        bilangan: 0,
        jumlahTempahan: 0,
        jumlahSelesai: 0,
        jumlahBelumSelesai: 0,
    });


    // ✅ Load User from LocalStorage
    useEffect(() => {
        if (!userData) { // ✅ Only fetch if userData is not set
            const storedUser = localStorage.getItem("user");
            if (storedUser) {
                try {
                    const parsedUser = JSON.parse(storedUser);
                    setUserData(parsedUser);
                } catch (error) {
                    console.error("❌ Ralat parsing user data:", error);
                }
            }
        }
    }, [userData]);


    useEffect(() => {
        if (userRole === "pengurus") {
            setSelectedModule("Kedai");
            console.log("📌 Default module set to 'Kedai' for pengurus.");
        }
    }, [userRole]);


    // ✅ Load Cart from LocalStorage & Expiry Handling
    useEffect(() => {
        const checkCart = () => {
            const storedCart = JSON.parse(localStorage.getItem("cart")) || { items: [], expiryTime: 0 };
            const currentTime = new Date().getTime();

            if (storedCart.expiryTime && currentTime > storedCart.expiryTime) {
                console.log("🛒 Cart expired. Clearing localStorage...");
                localStorage.removeItem("cart");
                setCartItems([]);
            } else {
                setCartItems(storedCart.items || []);
            }

            console.log("🛒 Troli dimuatkan:", storedCart);
            console.log("✅ Bilangan item dalam troli:", storedCart.items ? storedCart.items.length : 0);
        };

        checkCart();
        const interval = setInterval(checkCart, 60 * 1000); // ✅ Check every 1 min
        return () => clearInterval(interval);
    }, []);


    const isSelesai = (status) =>
        status === ORDER_STATUS.HQ_DELIVERED || status === "Selesai";


    useEffect(() => {
        const fetchSummary = async () => {
            if (userRole === "pengarah") {
                // PENGARAH: compiledOrders seluruh negeri
                const usersRef = collection(db, "inventori", "selangor", "users");
                const compiledOrdersRef = collection(db, "inventori", "selangor", "compiledOrders");

                // --- Jumlah pengerusi (guna Firestore count API)
                const pengerusiSnap = await getCountFromServer(query(usersRef, where("role", "==", "pengerusi")));

                // --- Ambil semua orders (tanpa filter)
                const allOrdersSnap = await getDocs(compiledOrdersRef);
                const allOrders = allOrdersSnap.docs.map(doc => ({
                    id: doc.id,
                    status: doc.data().status,
                    orderNumber: doc.data().orderNumber,
                    district: doc.data().district,
                }));

                // --- Debug output (boleh buang kalau dah stabil)
                console.log("[Pengarah] Semua compiledOrders:", allOrders);



                let jumlahSelesai = 0, jumlahBelumSelesai = 0;
                allOrders.forEach(o => {
                    if (isSelesai(o.status)) jumlahSelesai++;
                    else jumlahBelumSelesai++;
                });


                setSummary({
                    bilangan: pengerusiSnap.data().count,
                    jumlahTempahan: allOrders.length,
                    jumlahSelesai,
                    jumlahBelumSelesai,
                });
            }
            else if (userRole === "pengerusi" && userData?.district) {
                // PENGERUSI: orders ikut district dia sahaja
                const usersRef = collection(db, "inventori", "selangor", "users");
                const ordersRef = collection(db, "inventori", "selangor", "orders");

                // --- Bilangan pengurus ikut district sama
                const pengurusSnap = await getCountFromServer(query(
                    usersRef,
                    where("role", "==", "pengurus"),
                    where("district", "==", userData.district)
                ));

                // --- Ambil semua orders dalam district
                const ordersSnap = await getDocs(query(
                    ordersRef,
                    where("district", "==", userData.district)
                ));
                const orders = ordersSnap.docs.map(doc => ({
                    id: doc.id,
                    status: doc.data().status,
                    orderNumber: doc.data().orderNumber,
                    district: doc.data().district,
                }));

                // --- Debug output
                console.log("[Pengerusi] Semua orders district", userData.district, orders);

                // --- Kira selesai/belum selesai
                let jumlahSelesai = 0, jumlahBelumSelesai = 0;
                orders.forEach(o => {
                    if (isSelesai(o.status)) jumlahSelesai++;
                    else jumlahBelumSelesai++;
                });

                setSummary({
                    bilangan: pengurusSnap.data().count,
                    jumlahTempahan: orders.length,
                    jumlahSelesai,
                    jumlahBelumSelesai,
                });
            }
        };

        // Pastikan userRole dan userData ready sebelum fetch
        if (userRole && (userRole === "pengarah" || (userRole === "pengerusi" && userData?.district))) {
            fetchSummary();
        }
    }, [userRole, userData]);




    const modules = {
        pengurus: {
            OrderManagement: ["Kedai", "Tempahan"],
        },
        pengarah: {
            Dashboard: ["Dashboard"],
            UserManagement: ["Senarai Pengguna", "Tambah Pengguna"],
            StockManagement: ["Senarai Stok", "Tambah Stok"],
            OrderManagement: ["Pembekalan"],
            Reports: ["Laporan Stok", "Laporan Untung", "Untung Kawasan"],
            Tetapan: ["Tetapan"],
        },

        pengerusi: {
            Dashboard: ["Dashboard"],
            UserManagement: ["Senarai Pengguna", "Tambah Pengguna"],
            OrderManagement: ["Tempahan", "Pembekalan"],
            Reports: ["Untung Kawasan"],

        },
    };

    const roleModules = modules[userRole] || {};
    const menuItems = Object.values(roleModules).flat();

    // ✅ Handle Checkout Click
    const handleCheckoutClick = () => {
        setSelectedModule("Cart");

        if (window.innerWidth < 768) {
            console.log("📴 Closing sidebar after clicking 'Sahkan Tempahan'");
            setDrawerOpen(false);
        }
    };

    const handleLogout = () => {
        console.log("🔴 Logging out...");

        // 1️⃣ Kosongkan localStorage
        localStorage.removeItem("user");
        localStorage.removeItem("cart");
        setUserData(null);
        window.location.href = "/login";
    };


    // ✅ Handle Sidebar Toggle
    const toggleDrawer = () => {
        setDrawerOpen((prev) => {
            const newState = !prev;
            console.log(newState ? "✅ Sidebar Opened" : "🛑 Sidebar Closed");
            return newState;
        });
    };

    const confirmLeaveIfPending = () => {
        if (!hasPendingCompiled) return true;

        return window.confirm(
            "⚠️ Anda telah menambah order tetapi belum dihantar kepada pengarah.\n\n" +
            "Jika anda keluar sekarang, senarai pilihan akan RESET.\n\n" +
            "Teruskan keluar?"
        );
    };

    const safeSelectModule = (nextModule) => {
        if (nextModule === selectedModule) return;

        const ok = confirmLeaveIfPending();
        if (!ok) return;

        setSelectedModule(nextModule);

        if (window.innerWidth < 768) {
            setDrawerOpen(false);
        }
    };


    // ✅ Render Content Based on Selection
    const renderContent = () => {
        if (selectedModule === "Dashboard") {
            if (userRole === "pengerusi") {
                return (
                    <div style={{ margin: "20px" }}>
                        <SummaryCard data={[
                            { label: "Bilangan Pengurus", value: summary.bilangan },
                            { label: "Tempahan Diterima", value: summary.jumlahTempahan },
                            { label: "Selesai", value: summary.jumlahSelesai },
                            { label: "Belum Selesai", value: summary.jumlahBelumSelesai }
                        ]} />


                        <AlertPanel alerts={userData?.alerts || [
                            "Tiada notis setakat ini",

                        ]} />
                        <div style={{ display: "flex", gap: 8, margin: "15px 0" }}>
                            <button onClick={() => safeSelectModule("Tempahan")}>
                                Senarai Tempahan
                            </button>
                            <button onClick={() => safeSelectModule("Senarai Pengguna")}>
                                Senarai Pengguna
                            </button>

                        </div>
                    </div>
                );
            }
            if (userRole === "pengarah") {
                return (
                    <div style={{ margin: "20px" }}>
                        <SummaryCard data={[
                            { label: "Bilangan Pengerusi", value: summary.bilangan },
                            { label: "Tempahan Diterima", value: summary.jumlahTempahan },
                            { label: "Selesai", value: summary.jumlahSelesai },
                            { label: "Belum Selesai", value: summary.jumlahBelumSelesai }
                        ]} />


                        <AlertPanel alerts={userData?.alerts || [
                            "Tiada notis setakat ini",

                        ]} />
                        <div style={{ display: "flex", gap: 8, margin: "15px 0" }}>
                            <button onClick={() => setSelectedModule("Senarai Stok")}>
                                Senarai Stok
                            </button>
                            <button onClick={() => setSelectedModule("Laporan Untung")}>
                                Laporan Untung
                            </button>
                            <button onClick={() => setSelectedModule("Senarai Pengguna")}>
                                Senarai Pengguna
                            </button>
                        </div>
                    </div>
                );
            }
            return <h2>Welcome to Dashboard</h2>;
        }
        // --- Yang lain kekal seperti asal ---
        switch (selectedModule) {
            case "Senarai Pengguna":
                return <UserList currentRole={userRole} currentUserId={userId} />;
            case "Tambah Pengguna":
                return <UserForm currentRole={userRole} currentUserId={userId} currentDistrict={userDistrict} onMenuSelect={setSelectedModule} />;
            case "Senarai Stok":
                return <StockList userRole={userRole} />;
            case "Tambah Stok":
                return <StockForm />;
            case "Tempahan":
                return <OrderList onPendingChange={setHasPendingCompiled} />;

            case "Kedai":
                return <OrderForm onMenuSelect={setSelectedModule} />;
            case "Pembekalan":
                return <OrderListCompiled userRole={userRole} currentDistrict={userDistrict} pengerusiName={userData?.name || "Tidak Dikenalpasti"} />;
            case "Laporan Stok":
                return <StockReport />;
            case "Laporan Untung":
                return <ProfitReport />;
            case "Untung Kawasan":
                return <ProfitByDistrict />;
            case "Cart":
                return <Cart cartItems={cartItems} setCartItems={setCartItems} userId={userId} onMenuSelect={setSelectedModule} />;
            case "Tetapan":
                return <OrderSettings />;
            default:
                return (
                    <div style={{ padding: 40, textAlign: "center", color: "#888" }}>
                        <h2>Selamat Datang ke Pasti App</h2>
                        <p>Sila pilih menu di sebelah untuk mula.</p>
                    </div>
                );

        }
    };



    return (
        <div className="dashboard-container">
            <Header
                title="Inventori"
                onMenuClick={toggleDrawer}
                userRole={userRole}
                drawerOpen={drawerOpen}
                cartItems={cartItems}
            />

            <div className="dashboard-content">
                <Sidebar
                    menuItems={menuItems}
                    onMenuSelect={(item) => {
                        console.log("✅ Selected menu item:", item);
                        safeSelectModule(item);
                    }}

                    selectedMenu={selectedModule}
                    drawerOpen={drawerOpen}
                    toggleDrawer={toggleDrawer}
                    setDrawerOpen={setDrawerOpen}
                    userData={userData}
                    cartItems={cartItems}
                    onCheckoutClick={handleCheckoutClick}
                    onLogout={handleLogout}

                />
                <div className="dashboard-main">{renderContent()}</div>
            </div>
        </div>
    );
};

export default Dashboard;
